import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import HomePageV2 from "../pages/HomePageV2";
import { LanguageContextProvider } from "components/contexts/LanguageContext";
import { routesDict } from "./content/routes-dict";

const MyRoutes = (
  <HashRouter>
    <LanguageContextProvider>
      <Routes>
        <Route path={routesDict.home.this} element={<HomePageV2 />} />
        <Route path={`${routesDict.home.this}/:lang`} element={<HomePageV2 />} />
      </Routes>
    </LanguageContextProvider>
  </HashRouter>
);

export default MyRoutes;
